import MyProgress from '@/components/shared/my-progress/MyProgress.component';
import MyReferenceLink from '@/components/shared/my-reference-link/MyReferenceLink.component';
import TasksCompletingRates from '@/components/shared/tasks-completing-rates/TasksCompletingRates.components';
/* import { useQuestsQuery } from '@/store/services/QuestApi.service'; */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LeaderboardWidget } from '@/components';

import { useHomeControllerGetUserHomeDataQuery } from '@/store/services/MidleNestApi.service';

import { MyClan } from './my-clan';
import { Outlet } from 'react-router-dom';

export default function ProfileView() {
  const { t } = useTranslation();

  const { data: home, isLoading } = useHomeControllerGetUserHomeDataQuery();

  /* const {
   *   data: mainTasks,
   *   isLoading: mainTasksLoading,
   *   isUninitialized: mainTasksInit,
   * } = useQuestsQuery({ type: 'Main' });
   */
  /* const {
   *   data: dailyTasks,
   *   isLoading: dailyTasksLoading,
   *   isUninitialized: dailyTasksInit,
   * } = useQuestsQuery({ type: 'Daily' });
   */
  /* const {
   *   data: monthlyTasks,
   *   isLoading: monthlyTasksLoading,
   *   isUninitialized: monthlyTasksInit,
   * } = useQuestsQuery({
   *   type: 'Monthly',
   * });
   */

  return (
    <div className='profile max-w-7xl px-4 py-6 mx-auto space-y-4 lg:space-y-6'>
      <MyProgress className='' />
      <div className='space-y-4 lg:space-y-0 lg:space-x-6 lg:flex'>
        <MyReferenceLink />
        <TasksCompletingRates />
      </div>

      {/* <div className='space-y-4 lg:space-y-0 lg:space-x-6 lg:flex'>
          <TaskList title={t('Main Tasks')} loading={isLoading} tasks={?} />
          <TaskList title={t('Daily Tasks')} tasks={?} loading={isLoading} />
          <TaskList title={t('Monthly Tasks')} tasks={?} loading={isLoading} />
          </div>
        */}
      <div className='space-y-4 lg:space-y-0 lg:space-x-6 lg:flex'>
        <LeaderboardWidget
          loading={isLoading}
          users={home?.userLeaderboard.list}
          clans={home?.guildLeaderboard.list}
        />
        <MyClan />
      </div>

      <Outlet />
    </div>
  );
}
